<template>
    <div class="footerBox">
        <div class="footerFrame">
            <div class="nav item_footer">
                <span class="footerTitle">关于中安</span>
                <div
                    v-for="(item,index) in about"
                    :key="index"
                    @click="setAboutIndex('tab'+index)"
                >{{ item.typeName }}
                </div>
                <div @click="setAboutIndex('tabHonor')">资质荣誉</div>
            </div>
            <div class="footer_copy item_footer">
                <span class="footerTitle">地址：{{ address }}</span>
                <span>电话：{{ phone }}</span>
                <div>
                    <span>备案号：</span>
                    <a href="http://beian.miit.gov.cn/" target="_blank">{{ recordNumber }}</a>
                </div>
                <a class="gongan"
                   target="_blank"
                   :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode='+publicSecurityRecordNumber">
                    <img src="../assets/images/gongan.png" alt="公网安备">
                    <span>鲁公网安备：{{ publicSecurityRecordNumber }}号</span>
                </a>
            </div>
        </div>
        <div class="fix_right">
            <div class="item">
                <div :class="{hide:isHideTips}" class="tips">
                    <div class="close" @click="closeTips" title="关闭">x</div>
                    <div class="phone">{{ phone }}</div>
                </div>
                <div class="square" @click="mouseover">
                    <img src="../assets/images/tel1.png" alt="客服电话">
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import Store from "../store";

export default {
    name: 'footerComponents',
    data() {
        return {
            address: "",
            company: "",
            phone: "",
            publicSecurityRecordNumber: '',
            recordNumber: '',
            about: [],
            isHideTips: true,
        }
    },
    mounted() {
        this.getWebInfo()
        this.getAbout()
    },
    methods: {
        /**
         * 监听悬浮
         */
        mouseover() {
            this.isHideTips = !this.isHideTips
        },

        /**
         * 关闭
         */
        closeTips() {
            this.isHideTips = true
        },

        /**
         * 获取网站信息
         */
        getWebInfo() {
            this.$get('/V1/WebInfo/GetWebInfoDetail', {})
                .then((res) => {
                    // console.log('web', res)
                    if (res.success) {
                        this.address = res.response.address
                        this.company = res.response.company
                        this.publicSecurityRecordNumber = res.response.publicSecurityRecordNumber
                        this.recordNumber = res.response.recordNumber
                        this.phone = res.response.phone
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        },

        /**
         * 获取底部关于中安
         */
        getAbout() {
            this.$get('/V1/About/GetAboutList', {})
                .then((res) => {
                    // console.log('about', res)
                    if (res.success) {
                        this.about = res.response
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        },

        /**
         * 设置关于中安跳转索引
         */
        setAboutIndex(ind) {
            this.$store.commit('setAboutIndex', ind)
            Store.commit('setIndex', false)
            this.$router.push({name: 'Empty', params: {url: '/About'}})
        }
    }
}
</script>

<style scoped lang="less">
.footerBox {
    background-color: rgb(17, 17, 17);
    width: 100%;
    height: 280px;
    display: flex;
    flex-direction: row;
    align-items: center;
    z-index: 99;

    .footerFrame {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: flex-start;
        width: 1210px;
        margin: 0 auto;

        .nav {

            div {
                cursor: pointer;
            }
        }

        .item_footer {
            display: flex;
            flex-direction: column;

            * {
                font-size: 16px;
                color: #7b7978;
                margin-bottom: 10px;
            }

            .footerTitle {
                font-weight: bold;
                margin-bottom: 20px;
                color: white !important;
                font-size: 18px;
            }
        }

        .footer_copy {

            .gongan {
                display: flex;
                flex-direction: row;
                align-items: center;

                img {
                    margin-right: 5px;
                    margin-left: 0;
                }

                span {

                }
            }
        }
    }

    .fix_right {
        position: fixed;
        right: 0;
        top: 50%;

        .item {
            display: flex;
            flex-direction: row;
            align-items: center;
            cursor: pointer;

            .tips {
                background-color: white;
                position: absolute;
                right: 80px;
                min-width: 200px;
                text-align: center;
                min-height: 50px;
                line-height: 50px;
                border-radius: 3px;
                font-size: 20px;
                font-weight: bold;
                color: #1f2d5c;
                box-shadow: 0px 0px 5px 0px #bbbbbb;
                padding: 8px 5px;

                .close {
                    position: absolute;
                    right: 0;
                    top: -1px;
                    color: #474747;
                    font-size: 16px;
                    font-family: 微软雅黑;
                    line-height: 10px;
                    padding: 3px 5px 5px 5px;
                    cursor: pointer;
                    user-select: none;
                    z-index: 9999;
                }

                .phone {
                    line-height: 26px;
                }
            }


            .square {
                background-color: white;
                width: 70px;
                height: 70px;
                border-radius: 5px;
                box-shadow: 0px 0px 5px 0px #bbbbbb;


            }

        }
    }
}
</style>
